
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
/** `v-model`-compatible checkbox (emits `input` on toggle). */
export default class Checkbox extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Prop() label?: string;
  @Prop() border?: string;

  private switchValue(): void {
    this.$emit("input", !this.value);
  }
}
